import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
export var ReactivationModal = function ReactivationModal(_ref) {
  var onCtaClick = _ref.onCtaClick;
  return React.createElement("div", {
    className: "modal__reactivation"
  }, React.createElement("div", {
    className: "modal__header"
  }, React.createElement("img", {
    src: require('../../../static/img/modal-reactivation-welcome-bg.jpg'),
    alt: "reactivated"
  })), React.createElement("div", {
    className: "modal__body"
  }, React.createElement("div", {
    className: "modal__column"
  }, React.createElement("h3", {
    className: "delta sharp"
  }, React.createElement(FormattedMessage, {
    id: "reactivation.modal.header",
    defaultMessage: "Reunited & It Sure Feels Good!"
  })), React.createElement("div", {
    className: "mv+"
  }, React.createElement("p", null, React.createElement("span", {
    className: "md-block"
  }, React.createElement(FormattedMessage, {
    id: "reactivation.modal.welcome",
    defaultMessage: "Let us be the first to say \u2013 welcome back to ClassPass!"
  })), ' ', React.createElement(FormattedMessage, {
    id: "reactivation.modal.message",
    defaultMessage: "With your account reactivated, you can jump back into things and book your first class now!"
  }))), React.createElement("button", {
    onClick: function onClick() {
      return onCtaClick('ReactivationModal');
    },
    className: "bt bt--primary bt--lg"
  }, React.createElement(FormattedMessage, {
    id: "reactivation.modal.cta",
    defaultMessage: "Book class"
  })))));
};
ReactivationModal.propTypes = {
  onCtaClick: PropTypes.func.isRequired
};